import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ReplayControlsContent, ReplayControlsContentMinimal } from './ReplayControlsContent/index.ts';
import { useHotkeys } from 'react-hotkeys-hook';
const PLAYBACK_INTERVAL_MS = {
    '05x': 2000,
    '1x': 1000,
    '2x': 500,
    '4x': 250,
    '8x': 125
};
export const UIGameReplayControls = (props)=>{
    const playbackIntervalRef = useRef(null);
    const currentActionIndexRef = useRef(props.currentActionIndex);
    const [playbackSpeed, setPlaybackSpeed] = useState('1x');
    const [isPlaying, setIsPlaying] = useState(false);
    useEffect(()=>{
        currentActionIndexRef.current = props.currentActionIndex;
    }, [
        props.currentActionIndex
    ]);
    const stopPlayback = useCallback(()=>{
        if (playbackIntervalRef.current) {
            clearInterval(playbackIntervalRef.current);
            playbackIntervalRef.current = null;
        }
        setIsPlaying(false);
    }, []);
    useEffect(()=>()=>{
            stopPlayback();
        }, []);
    const startPlayback = useCallback(()=>{
        stopPlayback();
        playbackIntervalRef.current = setInterval(()=>{
            const currentActionIndex = currentActionIndexRef.current;
            const nextActionIndex = currentActionIndex + 1;
            const hasEnded = nextActionIndex >= props.numberOfActions;
            if (hasEnded) {
                stopPlayback();
                return;
            }
            props.onNextAction();
        }, PLAYBACK_INTERVAL_MS[playbackSpeed]);
        setIsPlaying(true);
    }, [
        playbackSpeed,
        props.numberOfActions,
        props.onNextAction
    ]);
    const onTogglePlayback = useCallback(()=>{
        if (playbackIntervalRef.current) {
            stopPlayback();
        } else {
            startPlayback();
        }
    }, [
        startPlayback,
        stopPlayback
    ]);
    const onChangePlaybackSpeed = useCallback((newPlaybackSpeed)=>{
        setPlaybackSpeed(newPlaybackSpeed);
        if (isPlaying) {
            startPlayback();
        }
    }, [
        startPlayback,
        isPlaying
    ]);
    const onSliderChangeActionIndex = useCallback((actionIndex)=>{
        stopPlayback();
        props.onChangeActionIndex(actionIndex);
    }, [
        stopPlayback,
        props.onChangeActionIndex
    ]);
    const onPreviousActionAndPause = useCallback(()=>{
        stopPlayback();
        props.onPreviousAction();
    }, [
        stopPlayback,
        props.onPreviousAction
    ]);
    const onNextActionAndPause = useCallback(()=>{
        stopPlayback();
        props.onNextAction();
    }, [
        stopPlayback,
        props.onNextAction
    ]);
    const onPreviousTurnAndPause = useCallback(()=>{
        stopPlayback();
        props.onPreviousTurn();
    }, [
        stopPlayback,
        props.onPreviousTurn
    ]);
    const onNextTurnAndPause = useCallback(()=>{
        stopPlayback();
        props.onNextTurn();
    }, [
        stopPlayback,
        props.onNextTurn
    ]);
    useHotkeys('space', onTogglePlayback);
    useHotkeys('left', onPreviousActionAndPause);
    useHotkeys('right', onNextActionAndPause);
    useHotkeys('shift+left', onPreviousTurnAndPause);
    useHotkeys('shift+right', onNextTurnAndPause);
    if (props.useMinimalReplayControls) {
        return /*#__PURE__*/ React.createElement(ReplayControlsContentMinimal, {
            ...props,
            isPlaying: isPlaying,
            onTogglePlayback: onTogglePlayback,
            onSliderChangeActionIndex: onSliderChangeActionIndex,
            onPreviousAction: onPreviousActionAndPause,
            onNextAction: onNextActionAndPause,
            disableTooltips: props.disableTooltips
        });
    }
    return /*#__PURE__*/ React.createElement(ReplayControlsContent, {
        ...props,
        isPlaying: isPlaying,
        playbackSpeed: playbackSpeed,
        onTogglePlayback: onTogglePlayback,
        onChangePlaybackSpeed: onChangePlaybackSpeed,
        onSliderChangeActionIndex: onSliderChangeActionIndex,
        onPreviousAction: onPreviousActionAndPause,
        onNextAction: onNextActionAndPause,
        onPreviousTurn: onPreviousTurnAndPause,
        onNextTurn: onNextTurnAndPause,
        disableTooltips: props.disableTooltips
    });
};
